// generated with ChatGPT
import { api, } from '../api/Api.js';
const MAX_RECENT_ERROR_KEYS = 20;
let isReporting = false;
const recentErrorKeys = [];
function isRecord(value) {
    return typeof value === 'object' && value !== null;
}
function toJsonSafeValue(value, seen = new WeakSet()) {
    if (value === null)
        return null;
    if (typeof value === 'string'
        || typeof value === 'number'
        || typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'bigint') {
        return value.toString();
    }
    if (typeof value === 'undefined'
        || typeof value === 'function'
        || typeof value === 'symbol') {
        return null;
    }
    if (value instanceof Error) {
        const result = {
            name: value.name,
            message: value.message,
        };
        if (value.stack !== undefined) {
            result.stack = value.stack;
        }
        return result;
    }
    if (value instanceof Date) {
        return value.toISOString();
    }
    if (Array.isArray(value)) {
        if (seen.has(value))
            return '[Circular]';
        seen.add(value);
        return value.map(item => toJsonSafeValue(item, seen));
    }
    if (isRecord(value)) {
        if (seen.has(value))
            return '[Circular]';
        seen.add(value);
        const result = {};
        for (const key of Object.keys(value).sort()) {
            const rawValue = value[key];
            // JSON.stringify drops undefined object properties, so do the same here.
            if (typeof rawValue === 'undefined')
                continue;
            result[key] = toJsonSafeValue(rawValue, seen);
        }
        return result;
    }
    return String(value);
}
function getStringProperty(value, key) {
    const property = value[key];
    return typeof property === 'string' ? property : undefined;
}
function serializeError(error) {
    if (error instanceof Error) {
        const result = {
            name: error.name,
            message: error.message,
        };
        if (error.stack !== undefined) {
            result.stack = error.stack;
        }
        return result;
    }
    if (isRecord(error)) {
        const details = toJsonSafeValue(error);
        const name = getStringProperty(error, 'name');
        const message = getStringProperty(error, 'message');
        const stack = getStringProperty(error, 'stack');
        const result = {
            message: message ?? JSON.stringify(details),
            details,
        };
        if (name !== undefined) {
            result.name = name;
        }
        if (stack !== undefined) {
            result.stack = stack;
        }
        return result;
    }
    return {
        message: String(error),
    };
}
function stableStringify(value) {
    return JSON.stringify(toJsonSafeValue(value));
}
function createDeduplicationKey(payload) {
    return stableStringify({
        type: payload.type,
        name: payload.name,
        message: payload.message,
        stack: payload.stack,
        source: payload.source,
        line: payload.line,
        column: payload.column,
        tagName: payload.tagName,
        componentStack: payload.componentStack,
        details: payload.details,
        url: payload.url,
        version: payload.version,
    });
}
function wasRecentlyReported(payload) {
    const key = createDeduplicationKey(payload);
    if (recentErrorKeys.includes(key)) {
        return true;
    }
    recentErrorKeys.push(key);
    if (recentErrorKeys.length > MAX_RECENT_ERROR_KEYS) {
        recentErrorKeys.shift();
    }
    return false;
}
export function reportClientError(payload) {
    const { details, ...payloadWithoutDetails } = payload;
    const enrichedPayload = {
        ...payloadWithoutDetails,
        url: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
        version: process.env.RELEASE_VERSION,
    };
    if (typeof details !== 'undefined') {
        enrichedPayload.details = toJsonSafeValue(details);
    }
    if (isReporting || wasRecentlyReported(enrichedPayload))
        return;
    isReporting = true;
    try {
        const body = JSON.stringify(enrichedPayload);
        if (navigator.sendBeacon) {
            const blob = new Blob([body], { type: 'application/json' });
            const queued = navigator.sendBeacon(api.common.error.url, blob);
            if (queued)
                return;
        }
        void fetch(api.common.error.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body,
            keepalive: true,
        });
    }
    catch (error) {
        // Never throw from the error reporter itself.
        console.error('Failed to report client error:', error);
    }
    finally {
        isReporting = false;
    }
}
export function installGlobalErrorHandlers() {
    const handleError = (event) => {
        reportClientError({
            type: 'js-error',
            message: event.message,
            source: event.filename,
            line: event.lineno,
            column: event.colno,
            ...serializeError(event.error),
        });
    };
    const handleResourceError = (event) => {
        const target = event.target;
        if (target instanceof HTMLScriptElement
            || target instanceof HTMLImageElement
            || target instanceof HTMLLinkElement) {
            reportClientError({
                type: 'resource-error',
                message: 'Resource failed to load',
                tagName: target.tagName,
                source: target instanceof HTMLLinkElement
                    ? target.href
                    : target.src,
            });
        }
    };
    const handleUnhandledRejection = (event) => {
        reportClientError({
            type: 'unhandled-rejection',
            ...serializeError(event.reason),
        });
    };
    window.addEventListener('error', handleError);
    window.addEventListener('error', handleResourceError, true);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    return () => {
        window.removeEventListener('error', handleError);
        window.removeEventListener('error', handleResourceError, true);
        window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
}
//# sourceMappingURL=clientErrorReporter.js.map